<div [@ngIfEnterWidth] *ngIf="isOpen" class="c-toolbox-content">
    <div class="c-toolbox-content__wrapper">
        <ng-content></ng-content>
    </div>
</div>
